import React from 'react';
import { CircularProgress } from '@mui/material';

export default function CustomLoading({
  size = 40,
  style = {},
  color = 'inherit'
}) {
  return (
    <CircularProgress
      size={size}
      color={color}
      style={{
        top: '50%',
        left: '50%',
        position: 'fixed',
        transform: 'translate(-50%, -50%)',
        ...style
      }}
    />
  );
}
